// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Stats_wrapper__2pQS2"};